module.exports = __webpack_public_path__ + "static/media/test-report.4bdfc188.svg";